import { render, staticRenderFns } from "./scheduleListSetting.vue?vue&type=template&id=5fbb981a&"
import script from "./scheduleListSetting.vue?vue&type=script&lang=js&"
export * from "./scheduleListSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/scheduleList/scheduleListSetting.vue"
export default component.exports